/* eslint-disable sort-imports, no-param-reassign, sonarjs/cognitive-complexity */

class MegaMenuItem {
  constructor(block) {
    this.block = block;

    this.selectors = {
      tabHeaderTitle: '.b-mega-menu__tab-header-title',
      link: '.b-mega-menu__tab-column-item-link',
      column: '.b-mega-menu__tab-column',
      image: '.b-mega-menu__tab-column-item-image',
      tab: '.b-mega-menu__tab',
    };

    this.classes = {
      tabHeaderTitleSelected: 'b-mega-menu__tab-header-title--selected',
      tabSelected: 'b-mega-menu__tab--selected',
      linkSelected: 'b-mega-menu__tab-column-item-link--selected',
      imageHidden: 'b-mega-menu__tab-column-item-image--hidden',
    };

    this.bootstrap();
  }

  bootstrap() {
    const links = [
      ...this.block.querySelectorAll(this.selectors.tabHeaderTitle),
    ];
    const tabs = [ ...this.block.querySelectorAll(this.selectors.tab) ];

    links.forEach((link, i) => {
      link.addEventListener('mouseover', () => {
        links.forEach(linkItem => {
          linkItem.classList.remove(this.classes.tabHeaderTitleSelected);
        });

        tabs.forEach(tab => {
          tab.classList.remove(this.classes.tabSelected);
        });

        link.classList.add(this.classes.tabHeaderTitleSelected);

        if (tabs[i]) {
          tabs[i].classList.add(this.classes.tabSelected);
        }
      });
    });

    const linkItems = [ ...this.block.querySelectorAll(this.selectors.link) ];

    linkItems.forEach(linkItem => {
      linkItem.addEventListener('mouseover', () => {
        const column = linkItem.closest(this.selectors.column);

        if (!column) {
          return;
        }

        const tab = column.closest(this.selectors.tab);
        const linksInColumn = [ ...tab.querySelectorAll(this.selectors.link) ];

        linksInColumn.forEach(link => {
          link.classList.remove(this.classes.linkSelected);
        });

        linkItem.classList.add(this.classes.linkSelected);

        const { image } = linkItem.dataset;

        if (!image) {
          return;
        }

        const imageDestination = column.querySelector(this.selectors.image);

        if (!imageDestination) {
          return;
        }

        if (imageDestination.nodeName === 'DIV') {
          imageDestination.style.backgroundImage = `url('${image}')`;
        }

        imageDestination.classList.remove(this.classes.imageHidden);
      });
    });
  }
}

export default class MegaMenu {
  constructor() {
    this.selector = '.b-mega-menu';
  }

  bootstrap() {
    this.wrappers = [ ...document.querySelectorAll(this.selector) ];

    this.wrappers.forEach(wrapper => new MegaMenuItem(wrapper));
  }
}
